export const Icons_L_Accent_02 = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="22 8 80 80"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.2,18.8c2.8-3.1,7.7-3.1,10.6,0,1.9,2.1,4.8,2.8,7.5,2,4-1.3,8.3,1.2,9.2,5.3.6,2.7,2.7,4.9,5.5,5.5,4.1.9,6.6,5.2,5.3,9.2-.8,2.7,0,5.6,2,7.5,3.1,2.8,3.1,7.7,0,10.6-2.1,1.9-2.8,4.8-2,7.5,1.3,4-1.2,8.3-5.3,9.2-2.7.6-4.9,2.7-5.5,5.5-.9,4.1-5.2,6.6-9.2,5.3-2.7-.8-5.6,0-7.5,2-2.8,3.1-7.7,3.1-10.6,0-1.9-2.1-4.8-2.8-7.5-2-4,1.3-8.3-1.2-9.2-5.3-.6-2.7-2.7-4.9-5.5-5.5-4.1-.9-6.6-5.2-5.3-9.2.8-2.7,0-5.6-2-7.5-3.1-2.8-3.1-7.7,0-10.6,2.1-1.9,2.8-4.8,2-7.5-1.3-4,1.2-8.3,5.3-9.2,2.7-.6,4.9-2.7,5.5-5.5.9-4.1,5.2-6.6,9.2-5.3,2.7.8,5.6,0,7.5-2Z"
      fill="#087d91"
      fillOpacity=".4"
    />
  </svg>
);

export const IconsLAccent01 = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="14 90 96 96"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.2,106.8c2.8-3.1,7.7-3.1,10.6,0,1.9,2.1,4.8,2.9,7.5,2,4-1.3,8.3,1.2,9.2,5.3.6,2.7,2.7,4.9,5.5,5.5,4.1.9,6.6,5.2,5.3,9.2-.8,2.7,0,5.6,2,7.5,3.1,2.8,3.1,7.7,0,10.6-2.1,1.9-2.8,4.8-2,7.5,1.3,4-1.2,8.3-5.3,9.2-2.7.6-4.9,2.7-5.5,5.5-.9,4.1-5.2,6.6-9.2,5.3-2.7-.8-5.6,0-7.5,2-2.8,3.1-7.7,3.1-10.6,0-1.9-2.1-4.8-2.9-7.5-2-4,1.3-8.3-1.2-9.2-5.3-.6-2.7-2.7-4.9-5.5-5.5-4.1-.9-6.6-5.1-5.3-9.2.8-2.7,0-5.6-2-7.5-3.1-2.8-3.1-7.7,0-10.6,2.1-1.9,2.8-4.8,2-7.5-1.3-4,1.2-8.3,5.3-9.2,2.7-.6,4.9-2.7,5.5-5.5.9-4.1,5.2-6.6,9.2-5.3,2.7.8,5.6,0,7.5-2Z"
      fill="#087d91"
    />
    <path
      d="M56.3,100.8c3.3-3.7,9.1-3.7,12.4,0,2.2,2.4,5.6,3.3,8.8,2.3,4.7-1.5,9.7,1.4,10.8,6.2.7,3.2,3.2,5.7,6.4,6.4,4.8,1.1,7.7,6,6.2,10.8-1,3.1,0,6.5,2.3,8.8,3.7,3.3,3.7,9.1,0,12.4-2.4,2.2-3.3,5.6-2.3,8.8,1.5,4.7-1.4,9.7-6.2,10.8-3.2.7-5.7,3.2-6.4,6.4-1.1,4.8-6,7.7-10.8,6.2-3.1-1-6.5,0-8.8,2.3-3.3,3.7-9.1,3.7-12.4,0-2.2-2.4-5.6-3.3-8.8-2.3-4.7,1.5-9.7-1.4-10.8-6.2-.7-3.2-3.2-5.7-6.4-6.4-4.8-1.1-7.7-6-6.2-10.8,1-3.1,0-6.5-2.3-8.8-3.7-3.3-3.7-9.1,0-12.4,2.4-2.2,3.3-5.6,2.3-8.8-1.5-4.7,1.4-9.7,6.2-10.8,3.2-.7,5.7-3.2,6.4-6.4,1.1-4.8,6-7.7,10.8-6.2,3.1,1,6.5,0,8.8-2.3Z"
      fill="#006475"
      fillOpacity=".2"
    />
  </svg>
);

export const Icons_L_Pink = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="130 8 80 80"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M165.2,18.8c2.8-3.1,7.7-3.1,10.6,0,1.9,2.1,4.8,2.8,7.5,2,4-1.3,8.3,1.2,9.2,5.3.6,2.7,2.7,4.9,5.5,5.5,4.1.9,6.6,5.2,5.3,9.2-.8,2.7,0,5.6,2,7.5,3.1,2.8,3.1,7.7,0,10.6-2.1,1.9-2.9,4.8-2,7.5,1.3,4-1.2,8.3-5.3,9.2-2.7.6-4.9,2.7-5.5,5.5-.9,4.1-5.1,6.6-9.2,5.3-2.7-.8-5.6,0-7.5,2-2.8,3.1-7.7,3.1-10.6,0-1.9-2.1-4.8-2.8-7.5-2-4,1.3-8.3-1.2-9.2-5.3-.6-2.7-2.7-4.9-5.5-5.5-4.1-.9-6.6-5.2-5.3-9.2.8-2.7,0-5.6-2-7.5-3.1-2.8-3.1-7.7,0-10.6,2.1-1.9,2.9-4.8,2-7.5-1.3-4,1.2-8.3,5.3-9.2,2.7-.6,4.9-2.7,5.5-5.5.9-4.1,5.1-6.6,9.2-5.3,2.7.8,5.6,0,7.5-2Z"
      fill="#f21b1b"
      fillOpacity=".3"
    />
  </svg>
);

export const IconsLRed = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="122 90 96 96"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M165.2,106.8c2.8-3.1,7.7-3.1,10.6,0,1.9,2.1,4.8,2.9,7.5,2,4-1.3,8.3,1.2,9.2,5.3.6,2.7,2.7,4.9,5.5,5.5,4.1.9,6.6,5.2,5.3,9.2-.8,2.7,0,5.6,2,7.5,3.1,2.8,3.1,7.7,0,10.6-2.1,1.9-2.9,4.8-2,7.5,1.3,4-1.2,8.3-5.3,9.2-2.7.6-4.9,2.7-5.5,5.5-.9,4.1-5.1,6.6-9.2,5.3-2.7-.8-5.6,0-7.5,2-2.8,3.1-7.7,3.1-10.6,0-1.9-2.1-4.8-2.9-7.5-2-4,1.3-8.3-1.2-9.2-5.3-.6-2.7-2.7-4.9-5.5-5.5-4.1-.9-6.6-5.1-5.3-9.2.8-2.7,0-5.6-2-7.5-3.1-2.8-3.1-7.7,0-10.6,2.1-1.9,2.9-4.8,2-7.5-1.3-4,1.2-8.3,5.3-9.2,2.7-.6,4.9-2.7,5.5-5.5.9-4.1,5.1-6.6,9.2-5.3,2.7.8,5.6,0,7.5-2Z"
      fill="#db1113"
    />
    <path
      d="M164.3,100.8c3.3-3.7,9.1-3.7,12.4,0,2.2,2.4,5.6,3.3,8.8,2.3,4.7-1.5,9.7,1.4,10.8,6.2.7,3.2,3.2,5.7,6.4,6.4,4.8,1.1,7.7,6,6.2,10.8-1,3.1,0,6.5,2.3,8.8,3.7,3.3,3.7,9.1,0,12.4-2.4,2.2-3.3,5.6-2.3,8.8,1.5,4.7-1.4,9.7-6.2,10.8-3.2.7-5.7,3.2-6.4,6.4-1.1,4.8-6,7.7-10.8,6.2-3.1-1-6.5,0-8.8,2.3-3.3,3.7-9.1,3.7-12.4,0-2.2-2.4-5.6-3.3-8.8-2.3-4.7,1.5-9.7-1.4-10.8-6.2-.7-3.2-3.2-5.7-6.4-6.4-4.8-1.1-7.7-6-6.2-10.8,1-3.1,0-6.5-2.3-8.8-3.7-3.3-3.7-9.1,0-12.4,2.4-2.2,3.3-5.6,2.3-8.8-1.5-4.7,1.4-9.7,6.2-10.8,3.2-.7,5.7-3.2,6.4-6.4,1.1-4.8,6-7.7,10.8-6.2,3.1,1,6.5,0,8.8-2.3Z"
      fill="#f21b1b"
      fillOpacity=".3"
    />
  </svg>
);
